<template>
  <div class="modal">
    <div class="modal-body modal-medium" v-on-clickaway:mousedown="closeModal">
      <div class="modal-content flex-col">
        <div class="flex items-center mb-4">
          <gwd-formlabel title="Lisa mall" :heading-level="3" />
        </div>
        <div class="flex flex-col">
          <div
            v-if="
              !template.description && (companyTemplates || clientTemplates)
            "
            class="grid items-center gap-x-2 w-full"
            :class="{
              'grid-cols-2':
                companyTemplates &&
                companyTemplates.length > 0 &&
                clientTemplates &&
                clientTemplates.length > 0,
            }"
          >
            <gwd-formlabel
              v-if="companyTemplates && companyTemplates.length > 0"
              title="Ettevõtte mallid"
            />
            <gwd-formlabel
              v-if="clientTemplates && clientTemplates.length > 0"
              title="Kliendi mallid"
            />
            <select-search
              v-if="companyTemplates && companyTemplates.length > 0"
              class="p-2 w-full"
              :dataset="companyTemplates"
              :filter-func="
                (template, query) => {
                  return template.description
                    .toLowerCase()
                    .includes(query.toLowerCase());
                }
              "
              :label="(item) => item.description"
              :show-on-focus="true"
              @input="copyCompanyTemplate"
            />
            <select-search
              v-if="clientTemplates && clientTemplates.length > 0"
              class="p-2 w-full"
              :dataset="clientTemplates"
              :filter-func="
                (template, query) => {
                  return template.description
                    .toLowerCase()
                    .includes(query.toLowerCase());
                }
              "
              :label="(item) => item.description"
              :show-on-focus="true"
              @input="copyCompanyTemplate"
            />
          </div>
          <div class="flex mb-2 w-full justify-between">
            <div class="flex flex-col mr-2 w-1/2">
              <gwd-formlabel title="Nimetus" />
              <input
                class="flex mb-2"
                type="text"
                v-model="template.description"
              />
            </div>
            <div class="flex flex-col ml-2 w-1/2">
              <gwd-formlabel title="Hind" />
              <decimal-input v-model="template.price" />
            </div>
          </div>
          <div class="flex mb-2 w-full justify-between">
            <div class="flex flex-col mr-2 w-1/2">
              <gwd-formlabel title="Käibemaks" />
              <gwd-tax-selector
                v-model="template.vatType"
                :allow-outgoing="true"
                :allow-empty="true"
              />
            </div>
            <div class="flex flex-col ml-2 w-1/2">
              <gwd-formlabel title="Ühik" />
              <select class="add-offer-input" v-model="template.unit">
                <option v-for="unit in units" :value="unit" :key="unit">
                  {{ unit }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-2 w-full flex justify-between">
            <div class="flex flex-col mr-2 w-1/2">
              <gwd-formlabel title="Tüüp" />
              <select v-model="template.type">
                <option
                  v-for="type in templateTypes"
                  :key="type.type"
                  :value="type.type"
                >
                  {{ type.description }}
                </option>
              </select>
            </div>
            <div class="flex flex-col ml-2 w-1/2">
              <gwd-formlabel title="Tulukood" />
              <select v-model="template.serviceCode">
                <option :value="null" :key="null">Puudub</option>
                <option
                  v-for="serviceObj in serviceCodes"
                  :key="serviceObj.id"
                  :value="serviceObj"
                  :disabled="serviceObj.service_code.length === 2"
                >
                  {{
                    `${serviceObj.service_code} - ${serviceObj.service_name}`
                  }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-bottom-bar">
        <button
          :disabled="!fieldsFilled"
          @click="fieldsFilled ? saveTemplate() : ''"
          class="mr-3"
          :class="fieldsFilled ? 'btn-primary' : 'btn-disabled'"
        >
          Salvesta
        </button>
        <button class="btn-danger" @click="closeModal">Sulge</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DecimalInput from "@/components/reusable/DecimalInput.vue";
import SelectSearch from "@/components/reusable/SelectSearch.vue";
import { set } from "lodash";

export default {
  name: "AddCostTemplateModal",

  components: { SelectSearch, DecimalInput },
  data() {
    return {
      template: {
        description: "",
        type: null,
        price: 0,
        vat: null,
        unit: null,
        taxType: null,
        vatType: null,
        serviceCode: null,
      },
      companyTemplates: [],
      clientTemplates: [],
      projectTemplates: [],
    };
  },
  async mounted() {
    document.body.classList.add("modal-open");

    if (!this.taxTypes)
      await this.$store.dispatch("companyVariables/retrieveTaxTypes");
    if (!this.serviceCodes) {
      await this.$store.dispatch("companyVariables/retrieveServiceObjects");
    }
    this.loadCompanyAndClientTemplates();
  },
  beforeDestroy() {
    document.body.classList.remove("modal-open");
  },
  methods: {
    loadCompanyAndClientTemplates() {
      this.apiRequest(
        `template/${this.companyId}/costs/templates/`,
        "get",
        true
      ).then((res) => {
        this.companyTemplates = res.data;
        for (let costTemplate of this.companyTemplates) {
          set(
            costTemplate,
            "vatType",
            this.taxTypes.find((x) => x.id === costTemplate.vat) ?? null
          );
          set(
            costTemplate,
            "templateType",
            this.templateTypes.find((x) => x.type === costTemplate.type) ?? null
          );
        }
      });
      let clientId;
      if (this.$store.state.pages.project.project?.client) {
        clientId = this.$store.state.pages.project.project.client.id;
      } else if (this.$store.state.modals.taskModal?.taskData?.related_object) {
        clientId =
          this.$store.state.modals.taskModal.taskData.related_object.client_id;
      }
      if (clientId) {
        this.apiRequest(
          `template/${this.companyId}/costs/templates/?type=client&object_id=${clientId}`,
          "get",
          true
        ).then((res) => {
          this.clientTemplates = res.data;
          for (let costTemplate of this.clientTemplates) {
            set(
              costTemplate,
              "vatType",
              this.taxTypes.find((x) => x.id === costTemplate.vat)
            );
            set(
              costTemplate,
              "templateType",
              this.templateTypes.find((x) => x.type === costTemplate.type) ??
                null
            );
          }
        });
      }
    },
    copyCompanyTemplate(e) {
      delete e["client"];
      delete e["task"];
      e.taxType = e.vatType;
      e.serviceCode =
        this.serviceCodes.find((x) => x.id === e.service_code) ?? null;
      this.template = JSON.parse(JSON.stringify(e));
    },
    closeModal() {
      this.$emit("closeModal");
    },
    saveTemplate() {
      this.$emit("templateSaved", this.template);
      this.closeModal();
    },
  },
  computed: {
    ...mapGetters({
      companyId: "companyData/activeCompanyUuid",
      taxTypes: "companyVariables/taxTypes",
      templateTypes: "companyVariables/templateTypes",
      units: "companyVariables/units",
      serviceCodes: "companyVariables/serviceObjects",
    }),
    fieldsFilled() {
      const temp = this.template;
      return temp.description && temp.type && temp.unit;
    },
  },
};
</script>
